import { getNfcNfcCardNoExchange } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { skipToken, useQuery } from "@tanstack/react-query";

const NFC_CARD_EXCHANGE_QUERY_KEY = "NFC_CARD_EXCHANGE";

export const nfcCardExchangeKeys = {
  all: [NFC_CARD_EXCHANGE_QUERY_KEY],
  byId: (nfcCardNo?: string) => [...nfcCardExchangeKeys.all, nfcCardNo],
};

export const useNfcCardExchangeQuery = (nfcCardNo?: string) =>
  useQuery({
    queryKey: nfcCardExchangeKeys.byId(nfcCardNo),
    queryFn: nfcCardNo
      ? processResponseWithApiProblemDetails(() =>
          getNfcNfcCardNoExchange(nfcCardNo),
        )
      : skipToken,
    enabled: !!nfcCardNo,
  });
